export class Point {
  constructor(x, y) {
    this.x = x;
    this.y = y;
  }

  static create(x = 0, y = 0) {
    return new Point(x, y);
  }
  static createFromTouchEvent(event) {
    var clientX = event.touches[0].clientX;                                    
    var clientY = event.touches[0].clientY;

    return new Point(clientX, clientY);
  }
  static createNil() {
    return undefined;
  }
  static getDiff(point1 = this.create(), point2 = this.create()) {
    return {
      xDiff: point1.x - point2.x,
      yDiff: point1.y - point2.y
    };
  }
}